import { Component, ElementRef} from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
export class ModalComponent {
  b2bHome = environment.b2bHome

  constructor (private element: ElementRef) {}

  showUnauthModal(){
    window['oneX'].Modal.showModal(this.element.nativeElement, 'unAuthModalContainer')
  }

  showForbiddenModal(){
    window['oneX'].Modal.showModal(this.element.nativeElement, 'forbiddenModalContainer')
  }

}
